export const skillsData = {
    frontend: ["HTML/CSS", "JavaScript (ES6+)", "React", "Tailwind CSS", "Bootstrap"],
    backend: ["Java", "Python", "Node.js", "Express.js", "SQL/PSQL"],
    tools: ["Git & GitHub", "C++", "C", "WordPress", "Figma", "AWS Lightsail"]
};

export const projectsData = [
    {
        id: "portfolio",
        title: "This Portfolio Website",
        description: "A responsive and interactive single-page application built to showcase my skills and projects. Developed with React and Tailwind CSS.",
        tags: ["React", "Tailwind CSS", "JavaScript", "Portfolio"],
        link: "https://github.com/acharyaganga/acharyaganga.github.io"
    },
    {
        id: "blogsite",
        title: "Simple Blog Site",
        description: "A simple and intuitive blogging platform built with the MEAN Stack (MongoDB, Express, Angular, Node.js) using MVC architecture. Users can create, manage, and engage with blog posts through comments and reactions.",
        tags: ["JavaScript", "Angular", "Node.js", "Express", "MongoDB", "Full-Stack"],
        link: "https://github.com/acharyaganga/MEAN-Project"
    },
    {
        id: "searchengine",
        title: "Search Engine",
        description: "A Java search engine using PostgreSQL, integrating Potter Stemmer and stopword filtering. Implements advanced search algorithms, PageRank, and indexing techniques for document retrieval. Features inverted indices for quick, precise searches across vast datasets and link graph analysis for result prioritization.",
        tags: ["Java", "PostgreSQL", "Gradle", "Tomcat", "Search Algorithms", "PageRank"],
        link: "https://github.com/acharyaganga/",
        label: "private repo"
    },
    {
        id: "umleditor",
        title: "UML Editor",
        description: "A Python-based UML Editor using MVC architecture for efficient CLI and GUI diagram management. Features a custom parser and CI/CD pipeline, ensuring application reliability with robust exception handling and 100% pytest coverage. Includes an accessible, user-friendly GUI, refined through user feedback.",
        tags: ["Python", "Tkinter", "Pygame", "pytest", "MVC", "CI/CD"],
        link: "https://github.com/acharyaganga/",
        label: "team project"
    }
];
